export const productImageFallback = `${process.env.BASE_URL || '/'}m_s_logo.svg`;

export function getProductImageFolder(articleName) {
  return String(articleName ?? '')
    .trim()
    .replace(/^(\d+)\s*\/\s*(?=\d)/, '$1_')
    .replace(/\//g, '');
}

export function handleProductImageError(event) {
  const image = event.target;
  if (image && image.getAttribute('src') !== productImageFallback) {
    image.src = productImageFallback;
  }
}
